// eslint-disable-next-line no-restricted-imports
import { DirectGoalCostType } from '../../../../data-layer/direct/types';
import { RUB } from '../../../../utils/char';
import { formatThousands } from '../../../../utils/format/formatThousands';

export const getGoalCostText = (
    goal?: { cost?: number; costType?: DirectGoalCostType },
    showCostType?: boolean,
) => {
    if (showCostType && goal?.costType === DirectGoalCostType.DYNAMIC) {
        return 'Динамическая';
    }

    if (goal?.cost) {
        return `${formatThousands(goal.cost)} ${RUB}`;
    }

    return 'Цена не задана';
};
